import styled from "styled-components";

const Wrapper = styled.div`
  display: inline-block;
  border: 1px solid #007aff;
  border-left: 0;
  border-radius: 0 2px 2px 0;
  vertical-align: bottom;
  min-height: 20px;
  // height: 20px;
  line-height: 20px;
  width: 504px;
  max-width: calc(100% - 20px);
  box-sizing: border-box;

  color: #007aff;
  font-weight: 600;
  font-family: sans-serif;
  font-size: 12px;
`;

export default Wrapper;
